/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  password: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
});
